import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import socket from "utils/Socket";
import storage from "utils/Storage";
import { decode, encode, sendNotfication, isEmail, Event, API } from 'utils/Helper';
import C from 'utils/Constant';
import { Link } from 'react-router-dom';

const StyledModal = styled(Modal)`
  .modal-dialog {
    margin: auto !important;
    @media(min-width:640px){
      max-width: 560px !important; /* Stake modal max width */
    }
  }
  .modal-content {
    background-color: #1A2C38; /* Stake card background */
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: white;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0,0,0,0.5);
    
    /* Scroller settings exactly like Stake */
    height: fit-content !important;
    max-height: 85vh !important;
    overflow-y: auto !important;
    
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #2F4553;
      border-radius: 4px;
    }
  }

  /* Force equal padding on top and bottom of the modal container */
  &.modal {
    padding-top: 5vh !important;
    padding-bottom: 5vh !important;
  }

  @media(max-width:340px){
    margin: 5px !important;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: #9CA3AF;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  line-height: 1;

  &:hover {
    color: white;
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 32px;
  position: relative;
  @media(max-width:400px){
    padding: 24px;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px; /* Stake spacing */
`;

const StyledInput = styled.input`
  background-color: #0F212E; /* Stake input background */
  border: 1px solid #2F4553;
  border-radius: 6px;
  color: white;
  padding: 0 16px;
  height: 48px;
  font-size: 14px;
  width: 100%;
  transition: all 0.2s ease-in-out;
  
  &::placeholder {
    color: #557086;
  }
  
  &:focus {
    outline: none;
    border-color: #1fdf71;
    background-color: #0F212E;
  }
`;

const StyledButton = styled.button`
  background-image: linear-gradient(90deg, #1fdf71, #84e056);
  box-shadow: rgba(31, 223, 113, 0.4) 0px 4px 14px 0px, rgba(255, 255, 255, 0.2) 0px 1px 0px inset;
  color: #0b2212;
  border: none;
  border-radius: 6px;
  height: 48px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  font-size: 14px;
  margin-top: 5px;
  transition: all 0.3s ease;

  &:hover {
    background-image: linear-gradient(90deg, #1bca66, #74cc4b);
  }
`;

const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #9CA3AF;
  margin-bottom: 6px;
  text-transform: capitalize;
`;

const FieldContainer = styled.div`
  margin-bottom: 12px;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

const Button = styled.button`
   padding: 10px 20px;
  border-radius: 7px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
`;

const SignUpButton = styled(Button)`
   background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
  color: black;
  border: none;
  width: 100%;
  max-width: 100%;
  max-height:100%;
  margin-top:10px;

  &:hover {
    background-color: #7c3aed;
  }
`;

const SendOtpButton = styled.button`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    height: 30px;
    padding: 0 10px;
    font-size: 0.9rem;
    border: none;
    color: black;
    border-radius: 4px;
    cursor: pointer;
     background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
`;

const SignInButton = styled(Button)`
    color: rgb(36 238 137);
  background:transparent;
  border:none;
`;

const CloseButtonNew = styled.div`
position:absolute;
top:10px;
right:10px;
font-size:18px;
display:none;

@media(max-width:640px){
display:block;
}
`;

const PhoneInputWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`;

const ForgetPassword = (props) => {
    const [isLogged] = useState(storage.getKey('logged'));
    const [show, setShow] = useState(props.show || false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [effect, setEffect] = useState('zoomIn');
    const [isOtp, setIsOtp] = useState(false);
    const [otp, setOtp] = useState('');
    const [expectedOtp, setExpectedOtp] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handleRegister = (data) => {
            const decodedData = decode(data);
            console.log(decodedData);
            if (decodedData.error) {
                setDisabled(false);
                setSubmitted(false);
                return sendNotfication(decodedData.error, 'success', 'bottom-left');
            }

            if (decodedData.status) {
                console.log("datataaaa", decodedData);
                sendNotfication('Successfully changed, Please loing...', 'success', 'bottom-left');
                Event.emit('login_form');
            }
        };

        socket.on(C.EDIT_FORGET_PASSWORD, handleRegister);
        const handleShowForm = () => {
            setShow(true);
            setEffect('zoomIn');
        };
        Event.on('register_form', handleShowForm);

        return () => {
            socket.off(C.EDIT_FORGET_PASSWORD, handleRegister);
            // In a real app we might also remove Event listener here
        };
    }, []);

    const handleShow = () => {
        setShow(true);
        setEffect('zoomIn');
    };

    const handleCloseF = () => {
        setShow(false);
        setEffect('zoomOut');
        setDisabled(false);
        setSubmitted(false);
    };

    const handleSendOtp = async (e) => {
        if (e) e.preventDefault();
        setDisabled(true);

        if (!email) {
            sendNotfication('Please enter an email or phone number', 'error', 'bottom-left');
            setDisabled(false);
            return;
        }

        setLoading(true);
        try {
            const type = email.includes('@') ? 'email' : 'phone';
            const endpoint = type === 'email' ? '/api/users/send-otp' : '/api/users/send-phone-otp';
            const payload = type === 'email' ? { email: email } : { phone: email };

            const response = await fetch(`${API}${endpoint}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });
    
            const data = await response.json();
            setLoading(false);
            setDisabled(false);
    
            if (response.ok && data.status) {
                sendNotfication('OTP sent successfully!', 'success', 'bottom-left');
                setIsOtp(true);
            } else {
                sendNotfication(data.message || "Failed to send OTP", 'error', 'bottom-left');
            }            
        } catch (err) {
            console.error("Error sending OTP:", err);
            sendNotfication("Something went wrong", "error", "bottom-left");
            setLoading(false);
            setDisabled(false);
        }
    };

    const handleForgetSubmit = async (e) => {
        e.preventDefault();
        setSubmitted(true);
        setDisabled(true);

        if (!email || !otp || !password) {
            sendNotfication('Please fill all fields', 'error', 'bottom-left');
            setDisabled(false);
            return;
        }

        if (password !== confirmPassword) {
            sendNotfication('Passwords do not match', 'error', 'bottom-left');
            setDisabled(false);
            return;
        }

        if (password.length < 6) {
            sendNotfication('Password must be at least 6 characters', 'error', 'bottom-left');
            setDisabled(false);
            return;
        }

        socket.emit(C.EDIT_FORGET_PASSWORD, encode({ email, otp, password }));
    };



    return (
        <>
            {isLogged ? false : <div onClick={handleShow} className='' style={{ cursor: "pointer" }}>
                Forgot password?
            </div>}

            <StyledModal
                size="md"
                centered
                show={isLogged ? false : show}
                onHide={handleCloseF}
                aria-labelledby="register-modal"
                className={`animated ${effect}`}
            >
                <ModalBody>
                    <CloseButton onClick={handleCloseF}>×</CloseButton>
                    <div style={{ marginBottom: '24px' }}>
                        <img src={window?.siteConfig?.logo_big ? (API + window.siteConfig.logo_big) : "/assets/images/logo.png"} alt="Logo" style={{ height: '36px', objectFit: 'contain' }} />
                        <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: '20px 0 0 0', color: 'white' }}>Forgot Password</h2>
                    </div>

                    <StyledForm onSubmit={isOtp ? handleForgetSubmit : handleSendOtp}>

                        <FieldContainer>
                            <FieldLabel>Email Address or Phone Number</FieldLabel>
                            <StyledInput
                                type="text"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter Email Address or Phone Number"
                                disabled={isOtp}
                            />
                        </FieldContainer>

                        {isOtp && (
                            <>
                                <FieldContainer>
                                    <FieldLabel>OTP</FieldLabel>
                                    <StyledInput
                                        type="text"
                                        name="otp"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                        placeholder="Enter OTP"
                                    />
                                </FieldContainer>
                                <FieldContainer>
                                    <FieldLabel>New Password</FieldLabel>
                                    <StyledInput
                                        type="password"
                                        name="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Enter New Password"
                                    />
                                </FieldContainer>
                                <FieldContainer>
                                    <FieldLabel>Confirm New Password</FieldLabel>
                                    <StyledInput
                                        type="password"
                                        name="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        placeholder="Enter Confirm New Password"
                                    />
                                </FieldContainer>
                            </>
                        )}

                        <ButtonContainer>
                            <StyledButton type="submit" disabled={disabled || loading} style={{ width: '100%', marginTop: '10px' }}>
                                {(disabled || loading) && <span className="spinner-grow spinner-grow-sm mr-1" role="status" aria-hidden="true"></span>}
                                {isOtp ? "Reset Password" : "Send OTP"}
                            </StyledButton>
                        </ButtonContainer>
                        <div className="signup-button" style={{ display: 'flex', justifyContent: 'center', marginTop: '15px', color: '#9CA3AF' }}>
                            Remember your password?
                            <SignInButton type="button" onClick={() => { handleCloseF(); Event.emit('login_form'); }} style={{ marginLeft: '5px', padding: 0 }}><Link to={"/login"} style={{ color: '#3b82f6', textDecoration: 'none' }}>Sign In</Link></SignInButton>
                        </div>
                    </StyledForm>
                </ModalBody>
            </StyledModal>
        </>
    );
};

export default ForgetPassword;
